// extracted by mini-css-extract-plugin
export var textContainer = "index-module--textContainer--1aIbw";
export var mainText = "index-module--mainText--2ZBQ7";
export var secondaryText = "index-module--secondaryText--1PdNr";
export var maxText = "index-module--maxText--1WmWc";
export var paddingDiv = "index-module--paddingDiv--1uP5b";
export var label = "index-module--label--gQ2UR";
export var textInput = "index-module--textInput--1rEvu";
export var area = "index-module--area--iMOkS";
export var errorField = "index-module--errorField--Nq64e";